import { selectWarehouse } from 'containers/Warehouses/warehousesSlice'
import { useHistory, useParams } from 'react-router-dom'
import ArrowBtn from 'components/buttons/ArrowBtn'
import useTranslation from 'hooks/useTranslation'
import BackBtn from 'components/buttons/BackBtn'
import usePopupState from 'hooks/usePopupState'
import Warehouse from 'components/Warehouse'
import { useReduxSelector } from 'store'
import RateUsPopup from './RateUsPopup'
import KeyReturn from './KeyReturn'

const Final = () => {
  const { popup, openPopup } = usePopupState<{ type: 'rateUs' }>()
  const { t } = useTranslation('warehouse')
  const { push } = useHistory()
  const { id } = useParams<warehouse.PageParams>()
  const { keyReturn } = useReduxSelector(state => selectWarehouse(state, id))

  return (
    <>
      {popup?.type === 'rateUs' && <div>
        <RateUsPopup />
      </div>}

      <div
        className='resignation__main'
        style={{ paddingTop: 0 }}>
        <div className='title'>
          <div>{t('thankYou')}</div>
          <div>{t('rentalCompleted')}</div>
        </div>

        <div className='resignation__summary'>
          <div className='resignation__warehouses'>
            {[1, 2, 3].map(e => <div
              key={e}
              className={`warehouse${e === 1 ? ' --left' : e === 3 ? ' --right' : ''}`}>
              <Warehouse />
            </div>)}
          </div>

          <div className='resignation__text'>{t('shareYourOpinionAndHelpUsImproveOurCompany')}</div>
        </div>

        <KeyReturn keyReturn={keyReturn} />

        <div className='resignation__buttons'>
          <ArrowBtn
            enlarged
            text={t('rateUs')}
            action={() => {
              openPopup({ type: 'rateUs' })
            }}
          />

          <BackBtn
            text={t('homePage')}
            action={() => push('/')}
          />
        </div>
      </div>
    </>
  )
}

export default Final